import moment from 'moment'
import { placements } from '../../models/advertisements/AdvertisementModel'

const present = value => value !== '' && value !== null && value !== undefined

export function tenantUnavailable (tenant, now = moment()) {
  return tenant.isActive === false || Boolean(tenant.license && (
    (tenant.license.validFrom && moment(tenant.license.validFrom).isAfter(now)) ||
    (tenant.license.validTo && moment(tenant.license.validTo).isBefore(now))
  ))
}

const AdvertismentFormValidation = (values, props = {}) => {
  const errors = {}

  if (values.name && values.name.length > 200) {
    errors.name = 'Maksymalnie 200 znaków'
  }
  if (values.description && values.description.length > 1000) {
    errors.description = 'Maksymalnie 1000 znaków'
  }
  if (values.targetUrl) {
    try {
      const url = new URL(values.targetUrl)
      if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) {
        errors.targetUrl = 'Podaj absolutny adres HTTP lub HTTPS'
      }
    } catch (error) {
      errors.targetUrl = 'Podaj absolutny adres HTTP lub HTTPS'
    }
  }
  if (present(values.order) && (!Number.isInteger(Number(values.order)) || Number(values.order) < 0)) {
    errors.order = 'Podaj liczbę całkowitą nieujemną'
  }

  if (present(values.validFrom) && !moment(values.validFrom).isValid()) {
    errors.validFrom = 'Nieprawidłowa data'
  }
  if (present(values.validTo) && !moment(values.validTo).isValid()) {
    errors.validTo = 'Nieprawidłowa data'
  }
  if (values.validFrom && values.validTo && moment(values.validTo).isBefore(moment(values.validFrom))) {
    errors.validTo = 'Data końcowa nie może poprzedzać początkowej'
  }

  const selectedTenants = values.tenantScope || []
  const unavailableTenants = (props.tenants || []).filter(tenant => tenantUnavailable(tenant))
  if (!selectedTenants.length) {
    errors.tenantScope = 'Wybierz co najmniej jednego operatora'
  } else if (unavailableTenants.some(tenant => selectedTenants.includes(tenant.id))) {
    errors.tenantScope = 'Usuń nieaktywnych operatorów lub operatorów bez ważnej licencji'
  }

  const selectedPlacements = values.placements || []
  const allowedPlacements = Object.values(placements).map(placement => placement.value)
  if (!selectedPlacements.length || selectedPlacements.some(value => !allowedPlacements.includes(value))) {
    errors.placements = 'Wybierz lokalizacje reklamy'
  }

  const platforms = ['mobile', 'web']
  platforms.forEach(platform => {
    const styles = (values.styles && values.styles[platform]) || {}
    const styleErrors = {}

    if (present(styles.width) && (!Number.isInteger(Number(styles.width)) || Number(styles.width) <= 0)) {
      styleErrors.width = 'Podaj dodatnią liczbę całkowitą'
    }
    if (present(styles.height) && (!Number.isInteger(Number(styles.height)) || Number(styles.height) <= 0)) {
      styleErrors.height = 'Podaj dodatnią liczbę całkowitą'
    }
    if (Object.keys(styleErrors).length) {
      errors.styles = { ...errors.styles, [platform]: styleErrors }
    }
  })

  return errors
}

export default AdvertismentFormValidation
